module.exports = __webpack_public_path__ + "img/img_STEP7.60232dc.png";